import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-custom-player',
  templateUrl: './custom-player.component.html',
  styleUrls: ['./custom-player.component.scss']
})
export class CustomPlayerComponent implements OnInit {

  mediaId: string;
  videoOnly = false;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe((params) =>{
      if (params.mediaId) {
        console.log('loading data with media id: ' + params.mediaId);
        this.mediaId = params.mediaId;
      }
    });

    this.route.queryParams.subscribe((params) => {
      if(params){
        this.videoOnly = params['videoOnly'];
      }
    })
  }

}
